import React from "react";
import { useDispatch } from "react-redux";
import { KevelCampaignControl } from "web/react/components/kevel-campaign-control";
import { ReviewCard } from "web/react/components/membership-promo-overlay/review-card";
import { TrustpilotWidget } from "web/react/components/trustpilot-widget";
import { Button } from "web/react/emo/button";
import { Heading } from "web/react/emo/heading";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import reviewData from "./customer-review-data.json";
import * as styles from "./membership-promo-overlay.css";

export type CardSizeType =
    | "none"
    | "xxxs"
    | "xxs"
    | "xs"
    | "sm"
    | "md"
    | "xm"
    | "lg"
    | "xl"
    | "xxl"
    | "xxxl";

export function MembershipPromoOverlay(): React.ReactElement {
    const dispatch = useDispatch();
    const { isDesktopViewport, isTabletViewport } = useDomViewport();

    const parseVariant = (index: number): CardSizeType => {
        switch (index) {
            case 0:
                return "xxxs";

            case 1:
                return "xxs";

            case 2:
                return "xs";

            case 3:
                return "sm";

            case 4:
                return "md";

            case 5:
                return "xm";

            case 6:
                return "lg";

            case 7:
                return "xl";

            case 8:
                return "xxl";

            case 9:
                return "xxxl";

            default:
                return "none";
        }
    };

    const openOverlay = (): void => {
        dispatch(
            openCustomerCaptureOverlay({
                analyticsEventLabel: "wishlist_anon_state",
                analyticsEventCategory: "wishlist",
                captureType: "save_for_later",
                titleKey: gettext("member_signup.member_products_love.title"),
                ctaKey: "general.continue",
            })
        );
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.signUpWrapper}>
                {/* Don't shop Around. */}
                <Heading
                    textStyle={
                        isDesktopViewport ? "hero-xl" : isTabletViewport ? "hero" : "title-1"
                    }
                >
                    {gettext("member_signup.dont_shop_around")}
                </Heading>
                <div className={styles.widgetWrapper}>
                    <TrustpilotWidget />
                </div>

                {/* Sign up to create wishlist */}
                <KevelCampaignControl
                    contextType={"wishlist_signup"}
                    defaultAction={openOverlay}
                    analyticsEventLabel={"wishlist_anon_state"}
                    beforeOnClick={() => {
                        analytics.event("wishlist", "sign_up", "wishlist_anon_state");
                    }}
                >
                    <div className={styles.button}>
                        <Button
                            width="full"
                            title={gettext("wishlist.signup_overlay_cta")}
                            onClick={openOverlay}
                        />
                    </div>
                </KevelCampaignControl>
            </div>

            <div className={styles.reviewWall}>
                {reviewData.map((r, i) => (
                    <ReviewCard key={r.id} review={r} variant={parseVariant(i)} />
                ))}
            </div>
        </div>
    );
}
